import { IconProps } from '../icon-props-interface';
import '../icons.scss';

export const IconDiscount = ({ color = 'var(--color-accent-1)' }: IconProps): JSX.Element => (
    <div className="icon-block">
        <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 16 16">
            <g clipPath="url(#clip0_70_2)">
                <rect width="16" height="16" fill={color} opacity="0.1" rx="8"></rect>
                <path
                fill="#4D79F7"
                fillRule="evenodd"
                d="M8.009 12.923a4.923 4.923 0 100-9.846 4.923 4.923 0 000 9.846zM6.949 6.94a.82.82 0 11-1.16-1.16.82.82 0 011.16 1.16zm3.282 2.121a.82.82 0 11-1.16 1.16.82.82 0 011.16-1.16zm-.144-2.266a.615.615 0 00-.87-.87l-3.284 3.28a.615.615 0 00.87.87l3.284-3.28z"
                clipRule="evenodd"
                ></path>
            </g>
            <defs>
                <clipPath id="clip0_70_2">
                <path fill="#fff" d="M0 0H16V16H0z"></path>
                </clipPath>
            </defs>
        </svg>
    </div>
);

export default IconDiscount;
